import React from 'react'
import Button from 'react-bootstrap/Button'

/**
 * Generates a button that is used to remove an applied filter.
 */
const RemoveFilterBtn = ({ disabled, onClick }) => {
  return (
    <Button
      className='remove-filter'
      variant='outline-primary'
      onClick={onClick}
    >
      Remove
    </Button>
  )
}

export default RemoveFilterBtn
